// fileUtils.js

/**
 * Converts a File object to a base64 string (without the data URI prefix).
 *
 * @param {File} file - The file to convert.
 * @returns {Promise<string>} - Resolves with the base64 string.
 */
export const toBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const base64 = reader.result.split(',')[1];
      resolve(base64);
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};